<template>
  <div>
    <v-tabs centered>
      <v-tab @click="tab = 1">
        <v-icon left>mdi-arrange-bring-to-front</v-icon>Herança
      </v-tab>
      <v-tab-item class="heranca-item">
        <heranca />
      </v-tab-item>
    </v-tabs>
  </div>
</template>
<script>
import Heranca from "./Heranca";

export default {
  name: "Herancas",
  components: {
    Heranca
  },
  data() {
    return {
      tab: "",
      breadcrumb: "EVENTOS"
    };
  },
  watch: {
    tab() {
      if (this.tab == 1) this.breadcrumb = "EVENTOS";
    }
  }
};
</script>